// This file is auto-generated. Do not edit manually.

export enum FeaturePermission {
  ACCESS_AND_EDIT_WAITLIST = "access_and_edit_waitlist",
  ADD_ADVERSE_REACTIONS = "add_adverse_reactions",
  ADD_RETAIL_PRODUCTS_AS_WALLET_ITEM = "add_retail_products_as_wallet_item",
  ADD_SERVICE_MENU_ITEMS_AS_WALLET_ITEM = "add_service_menu_items_as_wallet_item",
  ADD_SERVICE_PRODUCTS_AS_WALLET_ITEM = "add_service_products_as_wallet_item",
  ADJUST_CASH = "adjust_cash",
  APPROVE_DECLINE_WORK_SHIFTS = "approve_decline_work_shifts",
  ARCHIVE_CLINICAL_DOCUMENTS = "archive_clinical_documents",
  ARCHIVE_CONSENT_FORMS_SUBMISSIONS = "archive_consent_forms_submissions",
  ARCHIVE_INTAKE_FORMS_SUBMISSIONS = "archive_intake_forms_submissions",
  ASSIGN_REVENUE_ATTRIBUTION = "assign_revenue_attribution",
  ATTRIBUTED_TO_LINE_ITEMS = "attributed_to_line_items",
  BASIC_PERMISSIONS = "basic_permissions",
  CAN_BE_ATTRIBUTED_TO_SALE = "can_be_attributed_to_sale",
  CHARGE_PAYMENTS = "charge_payments",
  COMPLETE_APPOINTMENT = "complete_appointment",
  CONFIRM_CREATE_APPOINTMENT_ON_FD = "confirm_create_appointment_on_fd",
  CONNECT_CHERRY_INTEGRATION = "connect_cherry_integration",
  CREATE_APPOINTMENT = "create_appointment",
  CREATE_CLIENT = "create_client",
  CREATE_CLIENT_MEMBERSHIP = "create_client_membership",
  CREATE_INVOICE = "create_invoice",
  DELETE_ADVERSE_REACTIONS = "delete_adverse_reactions",
  DELETE_ALL_ADVERSE_REACTIONS = "delete_all_adverse_reactions",
  EDIT_ADVERSE_REACTION_STATUSES = "edit_adverse_reaction_statuses",
  EDIT_ADVERSE_REACTIONS = "edit_adverse_reactions",
  EDIT_ALL_ADVERSE_REACTION_STATUSES = "edit_all_adverse_reaction_statuses",
  EDIT_APPOINTMENT = "edit_appointment",
  EDIT_BRANDING_CUSTOMIZATION = "edit_branding_customization",
  EDIT_CHARTING_SETTINGS = "edit_charting_settings",
  EDIT_CLIENT = "edit_client",
  EDIT_CLIENT_COMMUNICATION_SETTINGS = "edit_client_communication_settings",
  EDIT_CLIENT_NOTE = "edit_client_note",
  EDIT_CLINICAL_DOCUMENTS_SETTINGS = "edit_clinical_documents_settings",
  EDIT_DISCOUNTS_AND_FEES_SETTINGS = "edit_discounts_and_fees_settings",
  EDIT_MEMBERSHIPS_SETTINGS = "edit_memberships_settings",
  EDIT_OFFICIAL_OFFERINGS_SETTINGS = "edit_official_offerings_settings",
  EDIT_ONLINE_BOOKING_SETTINGS = "edit_online_booking_settings",
  EDIT_ONLINE_STORE_SETTINGS = "edit_online_store_settings",
  EDIT_OWN_WORK_HOURS_SETTINGS = "edit_own_work_hours_settings",
  EDIT_PACKAGES_SETTINGS = "edit_packages_settings",
  EDIT_PAYMENT_PLANS_SETTINGS = "edit_payment_plans_settings",
  EDIT_PROVIDER_COLORS = "edit_provider_colors",
  EDIT_PROVIDERS_WORK_HOURS_SETTINGS = "edit_providers_work_hours_settings",
  EDIT_RESOURCES_SETTINGS = "edit_resources_settings",
  EDIT_RETAIL_PRODUCTS_SETTINGS = "edit_retail_products_settings",
  EDIT_SELECTIVE_BOOKING_LINKS_SETTINGS = "edit_selective_booking_links_settings",
  EDIT_SERVICE_MENU_SETTINGS = "edit_service_menu_settings",
  ELIGIBLE_FOR_PAYROLL_WORKER = "eligible_for_payroll_worker",
  GET_CLIENT_CREDIT_CARD_LINK = "get_client_credit_card_link",
  HAVE_MULTIPLE_USERMEDSPA = "have_multiple_usermedspa",
  IS_FRONT_DESK = "is_front_desk",
  IS_GFE_REVIEWER = "is_gfe_reviewer",
  IS_MEDICAL_DIRECTOR = "is_medical_director",
  IS_OWNER = "is_owner",
  IS_PROVIDER = "is_provider",
  IS_REQUIRED_TO_HAVE_WORK_SHIFTS_APPROVED = "is_required_to_have_work_shifts_approved",
  MANAGE_ADVERSE_REACTION_NOTES = "manage_adverse_reaction_notes",
  MANAGE_ALL_PROVIDER_COMPLIANCE_SETUP = "manage_all_provider_compliance_setup",
  MANAGE_APPOINTMENT_DIAGRAMS = "manage_appointment_diagrams",
  MANAGE_APPOINTMENT_NOTES = "manage_appointment_notes",
  MANAGE_CLIENT_FILES = "manage_client_files",
  MANAGE_CLIENT_LAB_RECORDS = "manage_client_lab_records",
  MANAGE_CLIENT_MEDICAL_HISTORY_REPORTS = "manage_client_medical_history_reports",
  MANAGE_CLIENT_MEMBERSHIP = "manage_client_membership",
  MANAGE_CLIENT_STATUS = "manage_client_status",
  MANAGE_CLIENT_TREATMENT_PLANS = "manage_client_treatment_plans",
  MANAGE_COMPLIANCE_MD_MEETINGS = "manage_compliance_md_meetings",
  MANAGE_COMPLIANT_NOTES = "manage_compliant_notes",
  MANAGE_CONSENT_FORM_DETAILS = "manage_consent_form_details",
  MANAGE_DASHBOARD_CHARTS = "manage_dashboard_charts",
  MANAGE_FEATURE_MANAGEMENT = "manage_feature_management",
  MANAGE_FORM_SUBMISSIONS_DETAILS = "manage_form_submissions_details",
  MANAGE_GFE_NOTES = "manage_gfe_notes",
  MANAGE_HIGHLEVEL = "manage_highlevel",
  MANAGE_INVENTORY = "manage_inventory",
  MANAGE_INVOICE_WALLET_CREDIT_LINES = "manage_invoice_wallet_credit_lines",
  MANAGE_ITEM_LINES = "manage_item_lines",
  MANAGE_MD_MEETINGS = "manage_md_meetings",
  MANAGE_MEMBERSHIP_PERK_CLIENT_CHOICE = "manage_membership_perk_client_choice",
  MANAGE_MOXIE_MANAGED_PC_COMPLIANCE_SETUP = "manage_moxie_managed_pc_compliance_setup",
  MANAGE_MSO_COMPLIANCE_SETUP = "manage_mso_compliance_setup",
  MANAGE_NON_MOXIE_PC_COMPLIANCE_SETUP = "manage_non_moxie_pc_compliance_setup",
  MANAGE_OTHER_EMPLOYEES_WORK_SHIFTS = "manage_other_employees_work_shifts",
  MANAGE_OTHERS_NOTIFICATIONS = "manage_others_notifications",
  MANAGE_OWN_NOTIFICATIONS = "manage_own_notifications",
  MANAGE_OWN_PROVIDER_COMPLIANCE_SETUP = "manage_own_provider_compliance_setup",
  MANAGE_OWN_WORK_SHIFTS = "manage_own_work_shifts",
  MANAGE_PAYROLL = "manage_payroll",
  MANAGE_PERMISSIONS_SETTINGS = "manage_permissions_settings",
  MANAGE_PHOTOS = "manage_photos",
  MANAGE_PRACTICE_ACCELERATOR = "manage_practice_accelerator",
  MANAGE_SCRIPT_REQUESTS = "manage_script_requests",
  MANAGE_SERVICE_PRODUCT_CHARTING_NOTES = "manage_service_product_charting_notes",
  MANAGE_SYNC_GFE_FILE_UPLOAD = "manage_sync_gfe_file_upload",
  MANAGE_SYNC_GFE_REVIEW = "manage_sync_gfe_review",
  MANAGE_TELEHEALTH_APPOINTMENT_DETAILS = "manage_telehealth_appointment_details",
  MANAGE_TIME_BLOCKS = "manage_time_blocks",
  MANAGE_WALLET_CREDIT_CARDS = "manage_wallet_credit_cards",
  MANAGE_WALLET_CREDIT_TYPE = "manage_wallet_credit_type",
  MARK_APPOINTMENT_SCHEDULED = "mark_appointment_scheduled",
  MERGE_CLIENTS = "merge_clients",
  REBOOK_CLIENT = "rebook_client",
  REFRESH_CHERRY_STATUS = "refresh_cherry_status",
  REFUND_INVOICE = "refund_invoice",
  REQUEST_GFE_REVIEW = "request_gfe_review",
  REQUEST_NEW_CONSENT_FORMS = "request_new_consent_forms",
  REQUEST_NEW_INTAKE_FORMS = "request_new_intake_forms",
  REQUIRE_ADDITIONAL_CONFIRMATION_IN_GFE_SIGNING = "require_additional_confirmation_in_gfe_signing",
  RETRY_MEMBERSHIP_CHARGE = "retry_membership_charge",
  REVIEW_CHARTS = "review_charts",
  REVIEW_GFE = "review_gfe",
  SEND_CHERRY_LINK_TO_CLIENT = "send_cherry_link_to_client",
  SEND_GFE_TO_MD_FOR_REVIEW = "send_gfe_to_md_for_review",
  SEND_INVOICE_RECEIPT = "send_invoice_receipt",
  SEND_LOGIN_LINK = "send_login_link",
  SEND_NO_SHOW_LATE_CANCELLED_INFO = "send_no_show_late_cancelled_info",
  SEND_UNSIGNED_FORMS = "send_unsigned_forms",
  SIGN_CHARTS = "sign_charts",
  SIGN_CLINICAL_DOCUMENTS = "sign_clinical_documents",
  SUBMIT_FIRST_FORM_SUBMISSION = "submit_first_form_submission",
  TRACK_WORK_SHIFTS = "track_work_shifts",
  UPDATE_CLIENT_DEFAULT_CREDIT_CARD = "update_client_default_credit_card",
  UPDATE_CLIENT_INTEREST_IN_PACKAGE_SUGGESTIONS = "update_client_interest_in_package_suggestions",
  UPDATE_CLIENT_INTEREST_IN_PAYMENT_PLANS = "update_client_interest_in_payment_plans",
  VERIFY_CASH = "verify_cash",
  VERIFY_CASH_ON_CLOCK_IN_OUT = "verify_cash_on_clock_in_out",
  VIEW_ADVERSE_REACTIONS = "view_adverse_reactions",
  VIEW_ALL_INVOICES = "view_all_invoices",
  VIEW_ALL_PROVIDER_COMPLIANCE_SETUP = "view_all_provider_compliance_setup",
  VIEW_AND_CLOSE_IN_APP_NOTIFICATIONS = "view_and_close_in_app_notifications",
  VIEW_APPOINTMENT = "view_appointment",
  VIEW_APPOINTMENT_CHARTS = "view_appointment_charts",
  VIEW_APPOINTMENT_DIAGRAMS = "view_appointment_diagrams",
  VIEW_APPOINTMENTS_HISTORY = "view_appointments_history",
  VIEW_BALANCE_PAGE = "view_balance_page",
  VIEW_BILLING = "view_billing",
  VIEW_BOOKKEEPING_PAGE = "view_bookkeeping_page",
  VIEW_BRANDING_CUSTOMIZATION = "view_branding_customization",
  VIEW_CANCELLED_APPOINTMENTS_REPORTS = "view_cancelled_appointments_reports",
  VIEW_CASH_REPORT = "view_cash_report",
  VIEW_CATEGORIES_WITH_CLIENT_INDICATIONS = "view_categories_with_client_indications",
  VIEW_CHART_SIGNATURES = "view_chart_signatures",
  VIEW_CHARTING_SETTINGS = "view_charting_settings",
  VIEW_CLIENT_ADVERSE_REACTIONS = "view_client_adverse_reactions",
  VIEW_CLIENT_APPOINTMENT_HISTORY = "view_client_appointment_history",
  VIEW_CLIENT_COMMUNICATION_SETTINGS = "view_client_communication_settings",
  VIEW_CLIENT_DETAILS = "view_client_details",
  VIEW_CLIENT_FILES = "view_client_files",
  VIEW_CLIENT_GFE_OVERVIEW = "view_client_gfe_overview",
  VIEW_CLIENT_LAB_RECORDS = "view_client_lab_records",
  VIEW_CLIENT_MEMBERSHIP = "view_client_membership",
  VIEW_CLIENT_PACKAGE_SUGGESTIONS = "view_client_package_suggestions",
  VIEW_CLIENT_TREATMENT_PLANS = "view_client_treatment_plans",
  VIEW_CLIENT_WALLET = "view_client_wallet",
  VIEW_CLIENT_WALLET_TRANSACTIONS = "view_client_wallet_transactions",
  VIEW_CLIENTS_REPORTS = "view_clients_reports",
  VIEW_CLINICAL_DIRECTIVES_SETTINGS = "view_clinical_directives_settings",
  VIEW_CLINICAL_DIRECTIVES_SETTINGS_MULTIPLE_MEDSPAS = "view_clinical_directives_settings_multiple_medspas",
  VIEW_CLINICAL_DOCUMENTS_SETTINGS = "view_clinical_documents_settings",
  VIEW_COMPLIANCE_ADVERSE_REACTIONS = "view_compliance_adverse_reactions",
  VIEW_COMPLIANCE_ALL_PROVIDERS = "view_compliance_all_providers",
  VIEW_COMPLIANCE_HUB = "view_compliance_hub",
  VIEW_COMPLIANCE_PROTOCOLS_STANDING_ORDERS = "view_compliance_protocols_standing_orders",
  VIEW_COMPLIANCE_SERVICE_DOCUMENTS = "view_compliance_service_documents",
  VIEW_COMPLIANT_NOTES = "view_compliant_notes",
  VIEW_CONSENT_FORM_DETAILS = "view_consent_form_details",
  VIEW_DASHBOARD_CHARTS = "view_dashboard_charts",
  VIEW_DISCOUNTS_AND_FEES_SETTINGS = "view_discounts_and_fees_settings",
  VIEW_EMPLOYEES_DETAILS = "view_employees_details",
  VIEW_FORM_SUBMISSIONS_DETAILS = "view_form_submissions_details",
  VIEW_FORMS_BASIC_INFO = "view_forms_basic_info",
  VIEW_FRONT_DESK_BOOKING_INFO = "view_front_desk_booking_info",
  VIEW_FULL_CLIENT_APPOINTMENT_HISTORY_DATA = "view_full_client_appointment_history_data",
  VIEW_FULL_CLIENT_FORMS_DATA = "view_full_client_forms_data",
  VIEW_GFE_DETAILS = "view_gfe_details",
  VIEW_HELP_DESK = "view_help_desk",
  VIEW_INVENTORY = "view_inventory",
  VIEW_MAIA_SMS_CONFIGURATION = "view_maia_sms_configuration",
  VIEW_MARKETING = "view_marketing",
  VIEW_MD_MEETINGS = "view_md_meetings",
  VIEW_MEMBERSHIPS_REPORTS = "view_memberships_reports",
  VIEW_MEMBERSHIPS_SETTINGS = "view_memberships_settings",
  VIEW_MESSAGES = "view_messages",
  VIEW_MSO_COMPLIANCE_SETUP = "view_mso_compliance_setup",
  VIEW_OFFICIAL_OFFERINGS_SETTINGS = "view_official_offerings_settings",
  VIEW_ONLINE_BOOKING_SETTINGS = "view_online_booking_settings",
  VIEW_ONLINE_STORE_SETTINGS = "view_online_store_settings",
  VIEW_OTHER_EMPLOYEES_WORK_SHIFTS = "view_other_employees_work_shifts",
  VIEW_OTHER_REPORTS = "view_other_reports",
  VIEW_OWN_PROVIDER_COMPLIANCE_SETUP = "view_own_provider_compliance_setup",
  VIEW_PACKAGES_SETTINGS = "view_packages_settings",
  VIEW_PAYMENTS_SETTINGS = "view_payments_settings",
  VIEW_PAYOUTS_REPORTS = "view_payouts_reports",
  VIEW_PHOTOS = "view_photos",
  VIEW_PRACTICE_ACCELERATOR = "view_practice_accelerator",
  VIEW_PROVIDER_APPOINTMENT_SUMMARY = "view_provider_appointment_summary",
  VIEW_PROVIDER_SPECIFIC_INFO = "view_provider_specific_info",
  VIEW_RESOURCES_SETTINGS = "view_resources_settings",
  VIEW_RETAIL_PRODUCTS_SETTINGS = "view_retail_products_settings",
  VIEW_SALES_REPORTS = "view_sales_reports",
  VIEW_SCRIPT_REQUESTS = "view_script_requests",
  VIEW_SELECTIVE_BOOKING_LINKS_SETTINGS = "view_selective_booking_links_settings",
  VIEW_SERVICE_MENU_SETTINGS = "view_service_menu_settings",
  VIEW_SETTINGS_PAGE = "view_settings_page",
  VIEW_SIGNED_CLINICAL_DOCUMENTS = "view_signed_clinical_documents",
  VIEW_STANDING_ORDERS = "view_standing_orders",
  VIEW_SUPPLIES_PAGE = "view_supplies_page",
  VIEW_SUPPLIES_SAVINGS = "view_supplies_savings",
  VIEW_SUPPLIES_SAVINGS_REPORTS = "view_supplies_savings_reports",
  VIEW_TRANSACTIONS_REPORTS = "view_transactions_reports",
  VIEW_WORK_HOURS_SETTINGS = "view_work_hours_settings",
}
